// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-form-toggle-area {\n    border-top: 1px solid var(--gray-300);\n}\n", ""]);
// Exports
module.exports = exports;
